import { render, staticRenderFns } from "./ExtraStatus.vue?vue&type=template&id=20884276"
import script from "./ExtraStatus.vue?vue&type=script&lang=js"
export * from "./ExtraStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports